import { supabase } from "@/integrations/supabase/client";

export async function getAuthHeaders(): Promise<{ authorization: string } | undefined> {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { authorization: `Bearer ${token}` } : undefined;
}
